import React from 'react';
import { Hero } from '../components/home/Hero';
import { Agenda } from '../components/home/Agenda';
import { Activites } from '../components/home/Activites';
import { Valeurs } from '../components/home/Valeurs';
import { Rejoindre } from '../components/home/Rejoindre';
export function Home() {
  return <main data-id="element-184" data-mp="2x5z92yfhu5e8">
      <Hero data-id="element-185" data-mp="2x4o7n59it9qa" />
      <Agenda data-id="element-186" data-mp="2x56boo2fcs8r" />
      <Activites data-id="element-187" data-mp="2x4wi6qi682yb" />
      <Valeurs data-id="element-188" data-mp="2x7iqiscvymhl" />
      <Rejoindre data-id="element-189" data-mp="1zi7ca5kcl676" />
    </main>;
}